<script setup lang="ts">
useSeoMeta({
  title: "Veranstaltungstechnik Pongau – Bühne, Ton & Licht mieten",
  ogTitle: "Veranstaltungstechnik Pongau – Bühne, Ton & Licht mieten | Mody",
  description: "Professionelle Veranstaltungstechnik im Pongau: Bühne, Beschallung & Licht für Firmenfeiern, Konzerte und Events. Mody Veranstaltungstechnik – direkt aus Flachau.",
  ogDescription: "Professionelle Veranstaltungstechnik im Pongau: Bühne, Beschallung & Licht für Firmenfeiern, Konzerte und Events. Mody Veranstaltungstechnik – direkt aus Flachau.",
})

const localBusinessJsonLd = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Mody Veranstaltungstechnik",
  "url": "https://mody.at/veranstaltungstechnik-pongau",
  "telephone": "+43 664 2247433",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Flachau",
    "postalCode": "5542",
    "addressRegion": "Salzburg",
    "addressCountry": "AT",
    "streetAddress": "Ennspark 193"
  },
  "areaServed": {
    "@type": "AdministrativeArea",
    "name": "Pongau"
  },
  "description": "Professionelle Veranstaltungstechnik im Pongau – Bühne, Ton und Licht für Events jeder Größe."
}

useHead({
  script: [
    { type: 'application/ld+json', innerHTML: localBusinessJsonLd }
  ]
})

const offerings = [
  { icon: 'pi pi-volume-up', title: 'Beschallung', description: 'PA-Anlagen für jede Größe – von der kleinen Vereinshütte bis zur großen Outdoor-Bühne im Tal.' },
  { icon: 'pi pi-sun', title: 'Lichttechnik', description: 'Moving Heads, PAR-Strahler, Laser und mehr – für stimmungsvolle Atmosphäre bei jedem Event.' },
  { icon: 'pi pi-home', title: 'Bühne', description: 'Unser StageTruck und modulare Bühnensysteme – ideal für Open-Air-Events und Festivals im Pongau.' }
]

const events = ['Brauchtumsfeste', 'Vereinsfeste', 'Konzerte', 'Firmenfeiern', 'Hochzeiten', 'Maturabälle', 'Open-Air-Events', 'Straßenfeste', 'Sportveranstaltungen']
const places = ['Flachau', 'Altenmarkt', 'Radstadt', 'St. Johann im Pongau', 'Bischofshofen', 'Eben im Pongau', 'Schwarzach', 'Werfen', 'Ennspongau']
</script>

<template>
  <LandingRegionalEventLanding
    kicker="Pongau"
    title="Veranstaltungstechnik Pongau"
    hero-description="Professionelle Bühne, Ton & Licht für Events im Pongau – direkt aus Flachau, für Firmenfeiern, Konzerte, Vereinsfeste und mehr."
    intro-heading="Euer Partner für Events im Pongau"
    :intro-paragraphs="[
      'Unser Lager in Flachau liegt mitten im Pongau – kurze Wege, schnelle Lieferung, persönlicher Service. Seit über 25 Jahren begleiten wir Events in St. Johann im Pongau, Bischofshofen, Radstadt, Altenmarkt und der gesamten Region.',
      'Vom Brauchtumsfest bis zur Firmenveranstaltung – wir kennen die Region und ihre Besonderheiten genau.'
    ]"
    offerings-heading="Was wir im Pongau anbieten"
    :offerings="offerings"
    events-heading="Events, die wir im Pongau betreuen"
    :events="events"
    service-heading="Unsere Orte im Pongau"
    service-description="Wir betreuen Events im gesamten Pongau und darüber hinaus."
    :places="places"
    cta-heading="Jetzt Angebot für euer Pongau-Event anfragen"
    cta-description="Kostenlos & unverbindlich. Wir melden uns schnell zurück mit einem individuellen Angebot."
  />
</template>
